module.exports = __webpack_public_path__ + "static/media/avatar.3fc78b45.png";